import { render, staticRenderFns } from "./LookDetail.vue?vue&type=template&id=e4da2b46&scoped=true"
import script from "./LookDetail.vue?vue&type=script&lang=js"
export * from "./LookDetail.vue?vue&type=script&lang=js"
import style0 from "./LookDetail.vue?vue&type=style&index=0&id=e4da2b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4da2b46",
  null
  
)

export default component.exports